export class ProjectBrowserController {

    constructor($log, $uibModalInstance, $http, AppConfig) {
        'ngInject';

        this.$log = $log;
        this.$uibModalInstance = $uibModalInstance;

        this.loading = true;

        $http.get(AppConfig.api_endpoint + '/api/sample-projects').then((response) => {
            this.samples = response.data;
            this.loading = false;
        });

    }

    select(sample) {
        this.selectedSample = sample;
    }

}



// WEBPACK FOOTER //
// ./src/js/components/project-browser/project-browser.controller.js